import { useMemo } from "react";
import type { JSX } from "react";

export const SORT_QUERY_PARAM = "sort";

/**
 * Hook para obter o valor atual do parâmetro de ordenação da URL
 * @returns O valor do parâmetro de ordenação ou string vazia
 */
export const useSort = () =>
  useMemo(() => {
    const urlSearchParams = new URLSearchParams(window.location?.search);
    return urlSearchParams.get(SORT_QUERY_PARAM) ?? "";
  }, []);

/**
 * Aplica a ordenação selecionada no select (desktop)
 * @param e - Evento do select
 */
export const applySort = (e: React.ChangeEvent<HTMLSelectElement>) => {
  const urlSearchParams = new URLSearchParams(window.location.search);
  urlSearchParams.set(SORT_QUERY_PARAM, e.currentTarget.value);
  window.location.search = urlSearchParams.toString();
};

/**
 * Aplica a ordenação selecionada no mobile
 * @param value - Valor da ordenação selecionada
 */
export const applySortMobile = (value: string) => {
  const urlSearchParams = new URLSearchParams(window.location.search);
  urlSearchParams.set(SORT_QUERY_PARAM, value);
  window.location.search = urlSearchParams.toString();
};

/**
 * Mapeamento de labels de ordenação para português
 */
export const portugueseMappings: Record<string, string> = {
  "relevance:desc": "Relevância",
  "price:desc": "Maior Preço",
  "price:asc": "Menor Preço",
  "orders:desc": "Mais vendidos",
  "name:asc": "A - Z",
  "name:desc": "Z - A",
  "release:desc": "Data de lançamento",
  "discount:desc": "Maior desconto",
};

